<template>
  <form @submit.prevent="submit">
    <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
      <header class="modal-card-head">
        <p class="modal-card-title">
          New Booking
          <span style="font-size:1rem; text-overflow: elipsis">{{ plant.name }}</span>
        </p>
      </header>
      <section class="modal-card-body">
        <b-field grouped>
          <b-field label="Crate Type">
            <b-select v-model="crateType" placeholder="Crate Type">
              <option value="1">
                1
              </option>
              <option value="5.1">
                5.1
              </option>
              <option value="5.2" selected>
                5.2
              </option>
              <option value="5.5">
                5.5
              </option>
              <option value="GPSFood">
                GPS Food
              </option>
              <option value="ZEON">
                ZEON
              </option>
              <option value="RHODIA">
                RHODIA
              </option>
            </b-select>
          </b-field>
          <b-field label="Quantity of crates">
            <b-input v-model="crateNum" type="number" />
          </b-field>
        </b-field>
        <b-field class="mb-1" grouped>
          <b-field label="Date">
            <b-datepicker
              v-model="date"
              name="date"
              :first-day-of-week="1"
              :locale="'en-CA'"
              icon="calendar-alt"
              placeholder="Date"
            />
          </b-field>
          <b-field label="Time">
            <b-input v-model="time" type="time" />
          </b-field>
          <b-field label="Activity">
            <b-button :type="leaving == true ? 'is-success' : 'is-light'" @click="changeLeaving(true)">
              Delivery/Transfer out
            </b-button>
            <b-button :type="leaving == false ? 'is-success' : 'is-light'" @click="changeLeaving(false)">
              Collect/Transfer in
            </b-button>
          </b-field>
        </b-field>
        <b-field label="Shipment Name">
          <b-input v-model="title" type="text" />
        </b-field>
        <b-field label="Comment">
          <b-input v-model="comment" type="text" />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button type="submit" class="button is-info is-fullwidth">
          {{ $t('global.submit') }}
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
// import enduserClosureMail from '@/services/v3/enduserClosureMail'

export default {
  props: {
    plant: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      output: [],
      date: new Date(),
      time: null,
      crateType: '5.2',
      crateNum: 150,
      comment: '',
      leaving: false,
      title: ''
    }
  },
  computed: {
  },
  mounted: async function () {
  },
  methods: {
    changeLeaving (leaving) {
      this.leaving = leaving
    },
    changeClean (clean) {
      this.clean = clean
    },
    async submit () {
      this.output.push(
        {
          num_crates: this.crateNum,
          status_crates: `${this.crateType}`,
          id_site: this.plant.id,
          leaving: this.leaving,
          comment: this.comment,
          title: this.title,
          date: this.date.toLocaleDateString('en-CA'),
          time: this.time || null
        }
      )
      try {
        this.$emit('submit', this.output)
      } catch (error) {
        this.$buefy.toast.open({ type: 'is-danger', message: error.message, duration: 3000 })
      }
    }
  }
}
</script>

<style>
</style>
